// RecommendedSection.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination'
import './../pagination_fix.sass'

import RecommendIcon from '../icons/RecommendIcon';
import SwiperArrowLeft from '../icons/SwiperArrowLeft';
import SwiperArrowRight from '../icons/SwiperArrowRight';

import ProductCardSm from './ProductCardSm';

import styles from './../style/RecommendedSection.module.scss';

class RecommendedSection extends React.Component {
  constructor(props) {
    super(props);
    this.swiperRef = React.createRef();
    this.nextSlide = this.nextSlide.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
  }

  nextSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext();
    }
  }

  prevSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev();
    }
  }

  render() {
    const { page_data, products, changeFavorite, favorite, cart, addTocart, user_profile_type } = this.props;

    if(products.length > 2) return (
      <section className={styles.recommendedSection}>
        <Container className={styles.container}>
          <div className={styles.sectionHeader}>
            <div className={styles.titleWrapper}>
              <h2 className={styles.sectionTitle}>Рекомендуем вам</h2>
              <RecommendIcon />
            </div>
            <a href={page_data?.link_catalog} className={styles.viewAll}>Смотреть все →</a>
          </div>
          
          <Swiper
            key={`swiper-${user_profile_type}`}
            ref={this.swiperRef}
            modules={[Navigation, FreeMode, Pagination]}
            pagination={{ type: `progressbar` }}
            spaceBetween={5}
            loop={true}
            slidesPerView={4}
            autoHeight={false}
            speed={100}
            observer={false}
            resizeObserver={false}
            breakpoints={{
              0: {
                slidesPerView: `auto`,
                spaceBetween: 5,
                freeMode: true
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 5
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 5
              },
              1400: {
                slidesPerView: 6,
                spaceBetween: 6
              }
            }}
          >
            {products.map((product) => (
              <SwiperSlide className={styles.productCard} key={product.id}>
                <ProductCardSm
                  id={product.id}
                  title={product.title}
                  image={product.image}
                  article={product.article}
                  manufacturer={product.manufacturer}
                  price={product.price}
                  old_price={product?.old_price}
                  inStock={product.inStock}
                  recomended={true}
                  changeFavorite={changeFavorite}
                  favorite={favorite}
                  cart={cart}
                  addTocart={addTocart}
                  user_profile_type={user_profile_type}
                  link={product.url}
                  certificate={product?.certificate}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          <div className={styles.swiperControls}>
            <button 
              className={`${styles.swiperButton} ${styles.swiperButtonPrev} d-none`}
              onClick={this.prevSlide}
            >
              <SwiperArrowLeft />
            </button>
            <div 
              style={{ display: `block` }}
              className={`${styles.swiperButton} ${styles.swiperButtonNext}`}
              onClick={this.nextSlide}
            >
              <SwiperArrowRight />
            </div>
          </div>
        </Container>
      </section>
    );
  }
}

RecommendedSection.propTypes = {
  page_data: PropTypes.object,
  products: PropTypes.array,
  changeFavorite: PropTypes.func,
  favorite: PropTypes.array,
  cart: PropTypes.array,
  addTocart: PropTypes.func,
  user_profile_type: PropTypes.string
};

RecommendedSection.defaultProps = {
  page_data: {},
  products: [],
  changeFavorite: () => {},
  favorite: [],
  cart: [],
  addTocart: () => {},
  user_profile_type: ''
};

export default RecommendedSection;